import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../Configurations/AuthContext';
import TopHeader from './TopHeader';
import SupplierTopHeader from '../../Supplier/SupplierTopHeader';

export default function AppLayout() {
  const { user } = useAuth();

  // Define special company types that should use SupplierTopHeader
  const specialCompanyTypes = ["VISA", "SERIESFAIR", "PACKAGE", "HOTEL", "SUPPLIER"];
  const useSupplierHeader = user && specialCompanyTypes.includes(user.companyType);
  
  return (
    <div id="layout-wrapper">
      {useSupplierHeader ? (
        <SupplierTopHeader />  
      ) : (
        <TopHeader />
      )}
      
      <Outlet /> 
    </div>
  );
}